import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core'
import {Observable} from 'rxjs'
import {map} from 'rxjs/operators'
import {LinkService} from '../../../../core/i18n/link.service'
import {faChevronLeft} from '@fortawesome/pro-solid-svg-icons/faChevronLeft'

@Component({
  selector: 'bgo-job-request-footer',
  templateUrl: './job-request-footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class JobRequestFooterComponent implements AfterViewInit, OnInit {
  @Input() nextButtonText?: string | null
  @Input() nextButtonLoading$?: Observable<boolean>
  @Input() showBackButton = false
  @Input() progressSteps?: FooterProgressSteps
  @Input() showPoweredByBuildigo = false
  @Output() nextButtonClick = new EventEmitter()
  @Output() cancelButtonClick = new EventEmitter()
  @Output() backButtonClick = new EventEmitter()
  stepWidthInPx?: number
  @ViewChild('footer') footerElement!: ElementRef<HTMLDivElement>

  steps$?: Observable<number[]>

  readonly backIcon = faChevronLeft

  constructor(
    private readonly cdr: ChangeDetectorRef,
    readonly linkService: LinkService,
  ) {}

  ngOnInit(): void {
    if (this.progressSteps) {
      this.steps$ = this.progressSteps.currentStep$.pipe(map(value => new Array(value)))
    }
  }

  ngAfterViewInit(): void {
    if (this.progressSteps) {
      this.stepWidthInPx = this.footerElement.nativeElement.scrollWidth / this.progressSteps.numberOfSteps
      this.cdr.detectChanges()
    }
  }
}

export interface FooterProgressSteps {
  numberOfSteps: number
  currentStep$: Observable<number>
}
